import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const contactBarSlide = () => {
  const contactBar = document.querySelector('.js-contact-bar')
  const contactBarSlideAnimation = gsap.to(contactBar, {
    y: '-=80',
    duration: 0.5,
    paused: true,
  })

  ScrollTrigger.create({
    trigger: 'nav',
    start: '2000px top',
    end: 99999,
    onUpdate: ({ progress, direction, isActive }) => {
      if (direction === -1) {
        contactBarSlideAnimation.reverse()
      } else if (direction === 1) {
        contactBarSlideAnimation.play()
      } else if (direction === 1 && isActive === true) {
        contactBarSlideAnimation.play()
      }
    },
  })
}
contactBarSlide()
